import type { Primitive } from '@apollo/client/utilities/types/Primitive'
import { captureException } from '@sentry/react'

// biome-ignore lint/suspicious/noExplicitAny:
export const report = (error: unknown, tags: { [key: string]: Primitive }, extra?: Record<string, any>) => {
  // @ts-ignore
  const reportedError = error instanceof Error ? error : new Error(error?.message ?? 'Non-generic error', { error })

  captureException(reportedError, {
    tags,
    extra,
  })
}
